import { renderColorImage } from './renderColorImage.js';
import { renderGrayscaleImage } from './renderGrayscaleImage.js';
import { renderWebImage } from './renderWebImage.js';

export default {
  colorImage: renderColorImage,
  grayscaleImage: renderGrayscaleImage,
  webImage: renderWebImage
};



// WEBPACK FOOTER //
// ./rendering/index.js